import React from "react";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

export default function PardotAuthCallBack() {

  const [message, setMessage] = useState('Authorizing ...');
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const uniqueId = localStorage.getItem('uniqueId');
  localStorage.removeItem('uniqueId');

  useEffect( ()=>{

    let authCode = params.get('code');
    let state = params.get('state');
    if(uniqueId === state && authCode && authCode !== ""){
        localStorage.setItem('pardot-auth-code',authCode);
        setMessage('Redirecting now ...');
    }else{
        setMessage('Authorization error occurred. Please try again.');
    }
    setTimeout(()=>{
        navigate("/settings/integration-setting-pardot-integration");
    }, 1000);

  },[])

  return (
    <div>
        <div>{message}</div>
    </div>
  );
}
